import { createSelector } from "@ngrx/store";
import { unsavedChangesFeature } from "src/app/state/unsaved-changes.reducer";

export const selectChanges = createSelector(
  unsavedChangesFeature.selectQueue,
  unsavedChangesFeature.selectSaving,
  (queue, saving) => queue.map((c) => ({ ...c, saving: c.id in saving })),
);
